// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiPeerToPeer {
    static getAttributeTypeMap() {
        return PharmacyBiPeerToPeer.attributeTypeMap;
    }
}
PharmacyBiPeerToPeer.discriminator = undefined;
PharmacyBiPeerToPeer.additionalProperties = false;
PharmacyBiPeerToPeer.attributeTypeMap = [
    {
        "name": "available",
        "baseName": "available",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "submissionDeadline",
        "baseName": "submissionDeadline",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiPeerToPeer.js.map